export const GET_USERS_SUCCESS = 'users/GET_USERS_SUCCESS';
export const GET_USER_SUCCESS = 'users/GET_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const TERMINATE_USER_SUCCESS = 'users/TERMINATE_USER_SUCCESS';

export const GET_USER_CLAIM_SUCCESS = 'users/GET_USER_CLAIM_SUCCESS';
export const CLEAR_SELECTED_CLAIM = 'users/CLEAR_SELECTED_CLAIM';

export const GET_DEPENDENTS_SUCCESS = 'users/GET_DEPENDENTS_SUCCESS';
export const ADD_DEPENDENT_SUCCESS = 'users/ADD_DEPENDENT_SUCCESS';
export const UPDATE_DEPENDENT_SUCCESS = 'users/UPDATE_DEPENDENT_SUCCESS';
export const REMOVE_DEPENDENT_SUCCESS = 'users/REMOVE_DEPENDENT_SUCCESS';

export const ADD_BENEFICIARY_SUCCESS = 'users/ADD_BENEFICIARY_SUCCESS';
export const UPDATE_BENEFICIARY_SUCCESS = 'users/UPDATE_BENEFICIARY_SUCCESS';
export const REMOVE_BENEFICIARY_SUCCESS = 'users/REMOVE_BENEFICIARY_SUCCESS';
export const UPDATE_CURRENT_BENEFICIARIES = 'users/UPDATE_CURRENT_BENEFICIARIES';

export const ADD_TRUSTEE_SUCCESS = 'users/ADD_TRUSTEE_SUCCESS';
export const UPDATE_TRUSTEE_SUCCESS = 'users/UPDATE_TRUSTEE_SUCCESS';
export const REMOVE_TRUSTEE_SUCCESS = 'users/REMOVE_TRUSTEE_SUCCESS';

export const REMOVE_NOTIFICATION_SUCCESS = 'users/REMOVE_NOTIFICATION_SUCCESS';

export const ADD_MEMBER_NOTE = 'users/ADD_MEMBER_NOTE';
export const GET_MEMBER_NOTES = 'users/GET_MEMBER_NOTES';

export const UPDATE_CLAIM = 'users/UPDATE_CLAIM';
export const GET_CLAIMS_SUCCESS = 'users/GET_CLAIMS_SUCCESS';
export const GET_HSA_CLAIMS_SUCCESS = 'users/GET_HSA_CLAIMS_SUCCESS';
export const GET_LSA_CLAIMS_SUCCESS = 'users/GET_LSA_CLAIMS_SUCCESS';
export const UPDATE_HSA_CLAIMS = 'users/UPDATE_HSA_CLAIMS';
export const UPDATE_LSA_CLAIMS = 'users/UPDATE_LSA_CLAIMS';

export const UPDATE_USER_BENEFIT_PREMIUMS = 'users/UPDATE_BENEFIT_PREMIUMS';

export const UPDATE_USER_BENEFIT_STATUS = 'users/UPDATE_USER_BENEFIT_STATUS';